module.exports = __webpack_public_path__ + "fonts/iconfont.0609193.ttf";